import React from "react";
import LegalLayout from "../../components/LegalLayout";

const sectionStyle = { marginBottom: 24 };
const h1Style = {
	fontSize: 28,
	fontWeight: 700,
	margin: "0 0 24px",
	color: "#0f172a",
};
const h2Style = {
	fontSize: 18,
	fontWeight: 600,
	margin: "20px 0 10px",
	color: "#334155",
};
const pStyle = { margin: "0 0 12px" };

export default function LegalTerminos() {
	return (
		<LegalLayout title="Términos y Condiciones">
			<h1 style={h1Style}>Condiciones de contratación</h1>

			<section style={sectionStyle}>
				<h2 style={h2Style}>1. Objeto</h2>
				<p style={pStyle}>
					Viajes Molones ofrece acceso a guías de viaje digitales y contenidos
					online destinados a la planificación de viajes.
				</p>
			</section>

			<section style={sectionStyle}>
				<h2 style={h2Style}>2. Naturaleza del servicio</h2>
				<p style={pStyle}>
					Viajes Molones proporciona guías digitales y contenidos informativos
					relacionados con la planificación de viajes.
				</p>
				<p style={pStyle}>
					La plataforma no actúa como agencia de viajes ni organiza transporte,
					alojamiento u otros servicios turísticos.
				</p>
			</section>

			<section style={sectionStyle}>
				<h2 style={h2Style}>3. Registro</h2>
				<p style={pStyle}>
					Para acceder a determinados contenidos es necesario crear una cuenta
					de usuario proporcionando información veraz. El servicio está dirigido
					a usuarios con edad mínima de 14 años; si eres menor de 14 años, necesitas el
					consentimiento de tus padres o tutores.
				</p>
				<p style={pStyle}>
					El usuario es responsable de la confidencialidad de sus credenciales.
				</p>
			</section>

			<section style={sectionStyle}>
				<h2 style={h2Style}>4. Productos digitales</h2>
				<p style={pStyle}>
					Los productos ofrecidos consisten en contenido digital accesible
					online y/o descargable.
				</p>
				<p style={pStyle}>
					El acceso se concede para uso personal y no comercial.
				</p>
			</section>

			<section style={sectionStyle}>
				<h2 style={h2Style}>5. Precio y pago</h2>
				<p style={pStyle}>
					Los precios se muestran en euros (€) e incluyen los impuestos
					aplicables salvo indicación contraria.
				</p>
				<p style={pStyle}>
					El pago se realiza mediante plataformas seguras externas (Stripe u
					otras).
				</p>
				<p style={pStyle}>
					<strong>Modalidades de acceso y pago.</strong> Viajes Molones puede
					ofrecer acceso a sus contenidos mediante:
				</p>
				<ul style={{ margin: "0 0 12px", paddingLeft: 24 }}>
					<li style={{ marginBottom: 8 }}>
						<strong>a) Suscripción:</strong> acceso a determinados contenidos
						mediante el pago periódico indicado en el momento de la contratación.
						La suscripción tendrá la duración especificada y podrá renovarse
						automáticamente salvo cancelación previa por parte del usuario.
					</li>
					<li style={{ marginBottom: 8 }}>
						<strong>b) Compra individual:</strong> acceso mediante pago único a
						una guía o contenido digital concreto, disponible para uso personal
						del usuario.
					</li>
				</ul>
				<p style={pStyle}>
					Las condiciones específicas, precio y duración se mostrarán siempre
					antes de confirmar la compra.
				</p>
			</section>

			<section style={sectionStyle}>
				<h2 style={h2Style}>6. Facturación</h2>
				<p style={pStyle}>
					Por cada compra tendrás derecho a recibir una factura o factura
					simplificada conforme a la normativa vigente, en la que constarán los
					datos fiscales del prestador del servicio. Puedes solicitarla por
					email en hola@viajesmolones.com; se te será emitida y enviada por
					correo electrónico en un plazo razonable.
				</p>
			</section>

			<section style={sectionStyle}>
				<h2 style={h2Style}>7. Acceso al contenido</h2>
				<p style={pStyle}>
					Tras la confirmación del pago, el acceso al contenido digital será
					inmediato desde la cuenta del usuario.
				</p>
				<p style={pStyle}>
					Las presentes condiciones están disponibles en todo momento en la web
					y constituyen la copia del contrato que puedes consultar o descargar
					(guardar o imprimir la página) cuando lo necesites.
				</p>
			</section>

			<section style={sectionStyle}>
				<h2 style={h2Style}>8. Cancelación de la suscripción</h2>
				<p style={pStyle}>
					Si has contratado una suscripción de pago periódico, puedes cancelarla
					en cualquier momento desde el área de cuenta o ajustes de la
					plataforma, o solicitándolo por email a hola@viajesmolones.com. La
					cancelación surtirá efecto al final del periodo ya abonado; no se
					realizarán cargos posteriores.
				</p>
			</section>

			<section style={sectionStyle}>
				<h2 style={h2Style}>9. Derecho de desistimiento. MUY IMPORTANTE</h2>
				<p style={pStyle}>
					De conformidad con el artículo 103.m del Real Decreto Legislativo
					1/2007:
				</p>
				<p style={pStyle}>
					El usuario acepta expresamente que, al iniciar el acceso al contenido
					digital, pierde su derecho de desistimiento al tratarse de contenido
					digital suministrado de forma inmediata.
				</p>
			</section>

			<section style={sectionStyle}>
				<h2 style={h2Style}>10. Propiedad intelectual</h2>
				<p style={pStyle}>
					Queda prohibida la reproducción, distribución o compartición del
					contenido adquirido sin autorización.
				</p>
			</section>

			<section style={sectionStyle}>
				<h2 style={h2Style}>11. Cancelación de cuentas</h2>
				<p style={pStyle}>
					El titular podrá suspender cuentas en caso de uso fraudulento o
					incumplimiento de las condiciones.
				</p>
				<p style={pStyle}>
					El usuario puede solicitar la baja de su cuenta y el tratamiento de sus
					datos conforme a lo indicado en la Política de Privacidad.
				</p>
			</section>

			<section style={sectionStyle}>
				<h2 style={h2Style}>12. Modificación de las condiciones</h2>
				<p style={pStyle}>
					El titular puede modificar estas condiciones. Los cambios se
					comunicarán mediante publicación en la web o por correo electrónico.
					El uso continuado del servicio tras la entrada en vigor de las
					modificaciones implica la aceptación de las mismas. Si los cambios
					afectan de forma sustancial a tus derechos como consumidor, podrás
					resolver el contrato antes de que entren en vigor.
				</p>
			</section>

			<section style={sectionStyle}>
				<h2 style={h2Style}>13. Disponibilidad del servicio</h2>
				<p style={pStyle}>
					El titular se esfuerza por mantener la disponibilidad de la
					plataforma, pero no garantiza un acceso ininterrumpido. Pueden
					producirse cortes por mantenimiento, causas de fuerza mayor o
					circunstancias ajenas al titular, sin que ello genere derecho a
					reclamación por el usuario.
				</p>
			</section>

			<section style={sectionStyle}>
				<h2 style={h2Style}>14. Responsabilidad</h2>
				<p style={pStyle}>
					Las guías tienen carácter informativo. El titular no garantiza cambios
					externos relacionados con horarios, precios o condiciones de terceros.
				</p>
			</section>

			<section style={sectionStyle}>
				<h2 style={h2Style}>15. Contenidos publicados por usuarios</h2>
				<p style={pStyle}>
					Algunos contenidos disponibles en la plataforma pueden haber sido
					creados por usuarios registrados.
				</p>
				<p style={pStyle}>
					Los usuarios que publiquen contenidos garantizan que disponen de los
					derechos necesarios sobre dichos materiales y que su publicación no
					infringe derechos de terceros.
				</p>
				<p style={pStyle}>
					Al publicar contenidos en la plataforma, el usuario concede al titular
					una licencia no exclusiva, mundial y gratuita para alojar, reproducir
					y mostrar dichos contenidos dentro del servicio con el fin de operar
					la plataforma.
				</p>
			</section>

			<section style={sectionStyle}>
				<h2 style={h2Style}>16. Legislación aplicable</h2>
				<p style={pStyle}>La relación se regirá por la legislación española.</p>
			</section>

			<section style={sectionStyle}>
				<h2 style={h2Style}>17. Competencia y foro</h2>
				<p style={pStyle}>
				Las presentes condiciones se regirán e interpretarán conforme a la legislación española. Cuando el usuario tenga la condición de consumidor y resida en la Unión Europea, serán competentes los juzgados y tribunales del domicilio del consumidor, de acuerdo con la normativa de protección de consumidores aplicable. En los demás casos, las partes se someten expresamente a los juzgados y tribunales de Barcelona (España), con renuncia a cualquier otro fuero que pudiera corresponderles.
				</p>
			</section>
		</LegalLayout>
	);
}
